export enum EnaioDocumentConversion {
    none = 0,
    allToPdf = 1,
    multiPageTiff = 8,
    allExceptOfficeToPdf = 16,
    toPdfOwnConversion = 100
}
export namespace EnaioDocumentConversion{
    export function getName(value: EnaioDocumentConversion): string {
        switch (value) {
            case EnaioDocumentConversion.none:
                return "none";
            case EnaioDocumentConversion.allToPdf:
                return "allToPdf";
            case EnaioDocumentConversion.multiPageTiff:
                return "multiPageTiff";
            case EnaioDocumentConversion.allExceptOfficeToPdf:
                return "allExceptOfficeToPdf";
            case EnaioDocumentConversion.toPdfOwnConversion:
                return "toPdfOwnConversion";
        }
    }
}
